<template>
    <div class="content">

      <div style="text-align: center;">
         <el-button type="warning" @click="qqBtn">點擊進入Q群:157841427</el-button>
         <br>
         <br><br><br><br>
         <el-button type="danger" @click="disBtn">點擊進入Discord群</el-button>
      </div>
     
    

    </div>
</template>
<script>
  export default {
    name: 'GroupSelect',
    data() {
      return {
        payBtn:false,
        server_name:'',
      };
    },
    created(){
           document.title = "CC谷";
    },
    methods: {
      qqBtn:function(){
        window.open("https://qun.qq.com/universal-share/share?ac=1&authKey=S0ZeIqcg1rAAO7nT/Hyv3a4P/O2%2BOjzKuwg27mMgofm3oOhkG1s0KixjPYnh/050&busi_data=eyJncm91cENvZGUiOiIxNTc4NDE0MjciLCJ0b2tlbiI6InBSSzRBc3piSFZoMEpRUXpCZFVKcFlUSkJGbXFQSGU3dXI0ZklkZkFCdE4zRWxTWFFvY0xhWjloUzlxc3ZuTkciLCJ1aW4iOiI0MDgzMjkzODcifQ==&data=eCGl-C7Xj59VB2QuPD1xh0VdBfAWSYDW73BR35PaLZtMUt07fHXg8lACuuNftpVePOKj-hpT6ldEjvdGRgAktfkStH3IASFwPntm7fyOUQE&svctype=5&tempid=h5_group_info");
      },
      disBtn:function(){
        window.open("https://discord.gg/2fB9xUSuU7");
      }

    },
  }
</script>
<style scoped>
    .title-class{
        padding-left: 140px;
        padding-top: 30px;
    }
    .get-role{
        margin-left: 10px;
    }
    .content{
        margin: 0 auto;
        margin-top: 50px;
        align-content: center;
        width: 50%;
        height: 600px;
        max-height: 800px;
        background-color: rgb(161, 194, 203);
        border-radius: 20px;
    }
    .form-class{
        padding-top: 20px;
        padding-left: 90px;
        width: 60%;
    }

</style>